import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import QuoteForm from './QuoteForm';
import HeroCurve from './HeroCurve';
import { HERO, LANDING_ASSETS, LANDING_COLORS } from '../../content/landingContent';

const FormCard = () => (
  <Box
    sx={{
      position: 'relative',
      bgcolor: '#fff',
      borderRadius: { xs: '16px', md: '12px' },
      p: { xs: 2.5, md: 3.5 },
      boxShadow: '0 8px 40px rgba(0,0,0,0.14)',
      zIndex: 3,
      mx: { xs: 0, md: 0 },
    }}
  >
    {/* Thumbs-up badge — desktop only */}
    <Box
      sx={{
        display: { xs: 'none', md: 'flex' },
        position: 'absolute',
        top: -18,
        right: -18,
        width: 48,
        height: 48,
        borderRadius: '50%',
        bgcolor: '#fff',
        boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 22,
        zIndex: 4,
      }}
    >
      👍
    </Box>

    <Typography
      sx={{
        fontFamily: 'Cabin, sans-serif',
        fontWeight: 700,
        fontSize: { xs: 22, md: 26 },
        color: LANDING_COLORS.purple,
        mb: 0.75,
      }}
    >
      {HERO.formTitle}
    </Typography>
    <Typography
      sx={{
        fontFamily: 'Cabin, sans-serif',
        fontSize: { xs: 13, md: 14 },
        color: LANDING_COLORS.textMuted,
        mb: { xs: 2, md: 2.5 },
        lineHeight: 1.5,
      }}
    >
      {HERO.formSubtitle}
    </Typography>
    <QuoteForm />
  </Box>
);

const HeroSection = () => (
  <Box
    id="hero-section"
    component="section"
    sx={{
      position: 'relative',
      color: '#fff',
      overflow: 'hidden',
      bgcolor: LANDING_COLORS.purple,
      backgroundImage: `url(${LANDING_ASSETS.heroBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center top',
      backgroundRepeat: 'no-repeat',
      pt: { xs: '88px', md: '104px' },
      pb: { xs: '80px', md: '108px' },
    }}
  >
    <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', lg: '1fr 460px' },
          gap: { xs: 3, md: 4, lg: 6 },
          alignItems: { xs: 'center', lg: 'center' },
        }}
      >
        {/* Left — headline */}
        <Box sx={{ textAlign: { xs: 'center', lg: 'left' } }}>
          {/* Badge — mobile only */}
          <Box
            sx={{
              display: { xs: 'inline-flex', md: 'none' },
              alignItems: 'center',
              gap: 1,
              px: 2,
              py: 0.75,
              mb: 2.5,
              borderRadius: '6px',
              bgcolor: LANDING_COLORS.badgeBg,
              border: `1px solid ${LANDING_COLORS.badgeBorder}`,
              fontFamily: 'Cabin, sans-serif',
              fontSize: 13,
            }}
          >
            <Box component="img" src={LANDING_ASSETS.heroBadgeMedal} alt="" sx={{ width: 18, height: 18 }} />
            {HERO.badge}
          </Box>

          <Typography
            component="h1"
            sx={{
              fontFamily: 'Cabin, sans-serif',
              fontWeight: 700,
              fontSize: { xs: 28, sm: 34, md: 48, lg: 58 },
              lineHeight: { xs: 1.2, md: 1.12 },
              mb: 2,
              maxWidth: { xs: '100%', lg: 620 },
              mx: { xs: 'auto', lg: 0 },
            }}
          >
            {HERO.title}
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Cabin, sans-serif',
              fontSize: { xs: 15, md: 17 },
              opacity: 0.92,
              maxWidth: { xs: '100%', lg: 520 },
              lineHeight: 1.55,
              mx: { xs: 'auto', lg: 0 },
            }}
          >
            {HERO.subtitle}
          </Typography>
        </Box>

        {/* Right — form card with glow behind */}
        <Box sx={{ position: 'relative' }}>
          {/* Purple glow orb behind form */}
          <Box
            aria-hidden
            sx={{
              position: 'absolute',
              bottom: { xs: -20, md: -30 },
              left: { xs: -20, md: -40 },
              width: { xs: 120, md: 180 },
              height: { xs: 120, md: 180 },
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(167, 99, 255, 0.55) 0%, transparent 70%)',
              filter: 'blur(8px)',
              zIndex: 1,
            }}
          />
          <Box sx={{ position: 'relative', mb: { xs: -6, md: 0 } }}>
            <FormCard />
          </Box>
        </Box>
      </Box>
    </Container>

    <HeroCurve />
  </Box>
);

export default HeroSection;
